import React, { useEffect, useState } from 'react';
import api from '../api';
import { useNavigate, useParams } from 'react-router-dom';
import { isStrongPassword, PASSWORD_POLICY_MESSAGE } from "../utils/passwordPolicy";

export default function EditTenant() {
  const { id } = useParams();
  const navigate = useNavigate();

  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [contact, setContact] = useState('');
  const [address, setAddress] = useState('');

  const [barangay, setBarangay] = useState(null);
  const [validId, setValidId] = useState(null);
  const [contract, setContract] = useState(null);

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    const load = async () => {
      try {
      const res = await api.get('/admin/tenants');
      const t = res.data.data.find(x => String(x.id) === String(id));
      if (!t) throw new Error('Tenant not found');

      setName(t.name);
      setEmail(t.email);
      setContact(t.contact_number || '');
      setAddress(t.address || '');
      } catch {
        setError('We couldn’t load this tenant. Return to the tenant list and try again.');
      } finally { setLoading(false); }
    };
    load();
  }, [id]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (password && !isStrongPassword(password)) {
      setError(PASSWORD_POLICY_MESSAGE);
      return;
    }

    try {
      setSaving(true);
      setError('');
      const form = new FormData();

      form.append("name", name);
      form.append("email", email);
      form.append("contact_number", contact);
      form.append("address", address);

      if (password) form.append("password", password);
      if (barangay) form.append("barangay_clearance", barangay);
      if (validId) form.append("valid_id", validId);
      if (contract) form.append("contract", contract);

      await api.post(`/admin/tenants/${id}?_method=PUT`, form, {
        headers: { "Content-Type": "multipart/form-data" }
      });

      navigate('/admin/tenants');

    } catch (err) {
      console.error(err);
      setError(err.response?.data?.message || 'We couldn’t save your changes. Please try again.');
    } finally { setSaving(false); }
  };

  if (loading) return <div>Loading...</div>;

  return (
    <div className="admin-page">
      <div className="card">

        <p className="ws-eyebrow">YOUR PEOPLE, WELL LOOKED AFTER</p>
        <h1>Edit tenant</h1>
        <p className="mt-3 mb-7 text-sm text-slate-400">Update contact details and keep onboarding documents in one place.</p>
        {error && <p role="alert" className="ws-error">{error}</p>}

        <form onSubmit={handleSubmit}>
          <div className="ws-form-grid">
            <label className="ws-field">Full name<input required value={name} onChange={e => setName(e.target.value)} autoComplete="name" /></label>
            <label className="ws-field">Email address<input required type="email" value={email} onChange={e => setEmail(e.target.value)} autoComplete="email" /></label>
            <label className="ws-field">Contact number<input type="tel" value={contact} onChange={e => setContact(e.target.value)} autoComplete="tel" /></label>
            <label className="ws-field">New password (optional)<input type="password" value={password} onChange={e => setPassword(e.target.value)} autoComplete="new-password" placeholder="Leave blank to keep current password" /></label>
          </div>
          <small>{PASSWORD_POLICY_MESSAGE}</small>
          <label className="ws-field">Address<textarea value={address} onChange={e => setAddress(e.target.value)} autoComplete="street-address" rows={3} /></label>

          {/* FILES */}
          <h2>Onboarding documents</h2>
          <p className="text-sm text-slate-400">Choose a file only when replacing an existing document.</p>
          <label className="ws-field">Replace barangay clearance<input type="file" onChange={(e) => setBarangay(e.target.files[0])} /></label>
          <label className="ws-field">Replace valid ID<input type="file" onChange={(e) => setValidId(e.target.files[0])} /></label>
          <label className="ws-field">Replace contract<input type="file" onChange={(e) => setContract(e.target.files[0])} /></label>

          <div style={{ marginTop: 10 }}>
            <button disabled={saving || !name || !email} type="submit">{saving ? 'Saving…' : 'Save changes'}</button>
            <button className="ws-button ws-button-secondary" type="button" onClick={() => navigate('/admin/tenants')}>Cancel</button>
          </div>
        </form>

      </div>
    </div>
  );
}
